// Shared Pool Party brand mark. Single change-point for the logo across
// every spot it appears today (Auth login hero, Auth region-blocked
// header, App auth-loading splash) and anywhere it lands in the future.
//
// Variants:
//   'lockup' — full horizontal lockup with wordmark (the big branded
//              moment — login hero, etc.)
//   'icon'   — icon-only mark (brief / small contexts — loading splash)
//
// Assets live in /public/brand/ and are referenced via plain URL strings
// (matches the owned-asset pattern in sport-bg/, ufc/, featured/). Vite
// serves /public from web root with no JS import needed.

const VARIANT_SRC = {
  icon:   '/brand/poolparty-icon.png',
  lockup: '/brand/poolparty-lockup.png',
}

export default function BrandMark({ variant = 'lockup', height = 64, style = {} }) {
  const src = VARIANT_SRC[variant] || VARIANT_SRC.lockup
  return (
    <img
      src={src}
      alt="Pool Party Sports"
      style={{
        height,
        width: 'auto',
        display: 'block',
        margin: '0 auto',
        ...style,
      }}
    />
  )
}
